import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type PinActivateResult @cacheControl(scope: PRIVATE, maxAge: 0) {\n    status: String\n    result: Boolean\n    deviceToken: String\n  }\n\n  type Mutation {\n    pinActivate(code: String): PinActivateResult\n  }\n"])));
export var resolvers = {
  Mutation: {
    pinActivate: function () {
      var _pinActivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var code, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                code = _ref.code;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.pinManager.pinActivate(code);

              case 5:
                res = _context.sent;
                return _context.abrupt("return", {
                  status: res === null || res === void 0 ? void 0 : res.status,
                  result: res === null || res === void 0 ? void 0 : res.result,
                  deviceToken: res === null || res === void 0 ? void 0 : res.device_token
                });

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.log("pinActivate schema error in resolver", _context.t0);
                return _context.abrupt("return", {
                  result: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      function pinActivate(_x, _x2, _x3) {
        return _pinActivate.apply(this, arguments);
      }

      return pinActivate;
    }()
  }
};